// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__14sq_","titlePart":"style_titlePart__2g9R0","pagesGrid":"style_pagesGrid__3T5-Q","pageItem":"style_pageItem__3Nzg3"};